<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Contra Referencia</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Tipo</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contraref in datosPaginados" :key="contraref.idContraRef">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(contraref.idContraRef)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(contraref.idContraRef)" title="Editar">edit_square</i></td>
          <td>{{contraref.tipo}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteContraRef(contraref.idContraRef)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idContraRef" class="form-label">IdContraRef</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idContraRef" name="idContraRef" v-model="datoContraRef.idContraRef" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Referencia Uno -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idReferenciaUno" class="form-label"> Referencia Uno</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idReferenciaUno" name="idReferenciaUno" v-model="datoContraRef.idReferenciaUno">
                      <option v-for="referenciaUno in referenciaUnos" :value="referenciaUno.idReferenciaUno" :key="referenciaUno.idReferenciaUno">
                        {{ referenciaUno.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Referencia Uno -->
<!-- Botón Lista de Valores  Referencia Dos -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idReferenciaDos" class="form-label"> Referencia Dos</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idReferenciaDos" name="idReferenciaDos" v-model="datoContraRef.idReferenciaDos">
                      <option v-for="referenciaDos in referenciaDoss" :value="referenciaDos.idReferenciaDos" :key="referenciaDos.idReferenciaDos">
                        {{ referenciaDos.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Referencia Dos -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoContraRef.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarContraRef" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditContraRef" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      contrarefs : [],
      datoContraRef : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      referenciaUnos: [],
      referenciaDoss: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchReferenciaUnos()
    this.fetchReferenciaDoss()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.contrarefs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcontrarefs/nombre/'+this.nombreBusqueda).then(response=>{
          this.contrarefs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.contrarefs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcontrarefs').then(response=>{
      this.contrarefs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.contrarefs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idReferenciaUno'
        ,'idReferenciaDos'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'idReferenciaUno'
        ,'idReferenciaDos'
        ,'tipo'
      ];
      return validarForm(this.datoContraRef, requiredFields, requiredFieldsText);
    },
    async guardarContraRef(){
      if(this.validarForm() === 1){
        try {
          await api.post('/contrarefs', this.datoContraRef)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ContraRef creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditContraRef(){
      if(this.validarForm() === 1){
        try {
          await api.post('/contrarefs', this.datoContraRef)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ContraRef creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoContraRef={}
      this.titulo   = 'Crear Contra Referencia'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idContraRef){
      this.modalWindow = true
      if(idContraRef != null){    
           api.get('/vwcontrarefs/'+idContraRef).then(resp=>{
          this.datoContraRef = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Contra Referencia'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idContraRef){
      if(idContraRef != null){
        this.$router.push('/contrarefmd/'+idContraRef)
      }
    },
    async deleteContraRef (idContraRef) {
      try{
        await api.delete('/contrarefs/'+idContraRef)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchReferenciaUnos() {
      fetch('http://localhost:8080/api/v1/referenciaunos')
        .then(response => response.json())
        .then(data => {
          this.referenciaUnos = data;
        })
        .catch(error => {
          console.error('Error fetching referenciaUnos:', error);
        });
    },
    fetchReferenciaDoss() {
      fetch('http://localhost:8080/api/v1/referenciadoss')
        .then(response => response.json())
        .then(data => {
          this.referenciaDoss = data;
        })
        .catch(error => {
          console.error('Error fetching referenciaDoss:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
